import type { Player } from '~/types'

export const useLoadPlayerBySlug = (slug: string, params: MaybeRef<Player.SearchRequest> = {}) => {
  const { view } = usePlayerApi()
  const isLoading = ref<boolean>(false)

  const { handleException } = useHandleException()

  const fetchData = async (): Promise<Player.Model | undefined> => {
    isLoading.value = true
    try {
      const { data } = await view(slug, params)

      return data
    }
    catch (ex: unknown) {
      handleException(ex)
      throw ex
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,

    fetchData,
  }
}
